import {
  FC,
  useRef,
  useState,
} from "react";

import {
  ArrowSmallDownIcon,
  CrossIcon,
  FolderIcon,
  LockIcon,
  SuccessIcon,
} from "@repo/edtech-assets";
import { useIsMobile } from "@repo/edtech-shared";
import { Modal } from "@repo/edtech-ui-kit";
import clsx from "clsx";

import {
  MOBILE_WIDTH,
  useMainContextValues,
} from "../../../../../../model";
import { getConfig } from "../../../../../../origins";
import { ListLesson } from "../list-lesson/ListLesson";

import st from "./UnitItem.module.scss";

type Props = {
  nodeId: string,
  isDisabledLesson: boolean,
  title: string,
  isPassed: boolean,
  isSubList: boolean,
  childrenList: string[],
  closeCourseContentAction?: () => void,
};

export const UnitItem: FC<Props> = ({
  nodeId,
  isDisabledLesson,
  title,
  isPassed,
  isSubList,
  childrenList,
  closeCourseContentAction,
}) => {
  const wrapRef = useRef<HTMLLIElement | null>(null);
  const isMobile = useIsMobile(MOBILE_WIDTH);
  const { currentLesson } = useMainContextValues();
  const { showCourseContentHover } = getConfig();

  const isUnitOpen = currentLesson?.nodeId === nodeId || currentLesson?.parentNodeIds?.includes(nodeId);

  const [ isShowLessons, setIsShowLessons ] = useState(isUnitOpen);
  const [ isMobileShowLessons, setMobileIsShowLessons ] = useState(false);

  const onClickShowMore = () => {
    if (isDisabledLesson || !childrenList?.length) return;
    setIsShowLessons((p) => !p);
    setMobileIsShowLessons(true);
  };

  return (
    <li
      ref={wrapRef}
      className={clsx(st.li, isSubList && st.sublist)}
    >
      <div
        className={
          clsx(
            st.main_line,
            isDisabledLesson && st.is_lock,
            isUnitOpen && st.is_active,
            showCourseContentHover ?
              st.background_hover :
              st.text_hover,
          )
        }
        role="button"
        onClick={onClickShowMore}
        onMouseDown={
          (e) => {
            if (e.detail > 1) {
              e.preventDefault();
            }
          }
        }
      >
        <span className={st.icon_wrap}>
          <FolderIcon />
        </span>

        <div className={st.title}>
          <span>{title}</span>
          <button
            className={
              clsx(
                st.show_more,
                isShowLessons && st.show_less,
                isDisabledLesson && st.disabled,
              )
            }
          >
            <ArrowSmallDownIcon />
          </button>
        </div>

        <span className={st.last_icon}>
          {isPassed && <SuccessIcon className={st.success_icon} />}
          {
            !isPassed && isDisabledLesson && (
              <LockIcon className={st.lock_icon} />
            )
          }
        </span>
      </div>
      {
        isShowLessons && (
          <div className={st.sublist_line}>
            <ListLesson
              isSubList
              closeCourseContentAction={closeCourseContentAction}
              currentList={childrenList}
            />
          </div>
        )
      }
      {
        isMobileShowLessons && isMobile && (
          <div className={st.sublist_line_mobile}>
            <Modal
              isCloseBtnHidden
              isFullScreenMobile
              closeOnBackDropClick={false}
              isOpen={isMobileShowLessons}
              propContainerRef={wrapRef?.current as HTMLElement}
              onClose={() => setMobileIsShowLessons(false)}
            >
              <>
                <div className={st.mobile_modal_header}>
                  <button
                    className={st.mobile_modal_prev}
                    type="button"
                    onClick={() => setMobileIsShowLessons(false)}
                  >
                    <ArrowSmallDownIcon />
                  </button>
                  <div className={st.mobile_modal_title}>
                    {title}
                  </div>
                  <button
                    className={st.mobile_modal_close}
                    type="button"
                    onClick={
                      () => {
                        setMobileIsShowLessons(false);
                        closeCourseContentAction?.();
                      }
                    }
                  >
                    <CrossIcon />
                  </button>
                </div>
                <ListLesson
                  isSubList
                  closeCourseContentAction={closeCourseContentAction}
                  currentList={childrenList}
                />
                <button
                  className={st.mobile_modal_close_btn}
                  onClick={closeCourseContentAction}
                >
                  Закрыть
                </button>
              </>
            </Modal>
          </div>
        )
      }
    </li>
  );
};
